// import $ from 'expose-loader?exposes=$,jQuery!jquery';

// import axios from 'axios';
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

import Config from './utilities/Config.js';
import Breakpoint from './utilities/Breakpoint.js';

import Scroller from './modules/Scroller.js';
import Click from './modules/Click.js';
import ScrollTo from './modules/ScrollTo.js';
import Obf from './modules/Obf.js';
import FixedHeader from './modules/FixedHeader.js';
import StepScroller from './modules/StepScroller.js';
import Comparison from './modules/Comparison.js';
import Rive from './modules/Rive.js';
import SectionHeader from './modules/SectionHeader.js';
import Navigation from './modules/Navigation.js';
import Slider from './modules/Slider.js';
import VariationSelector from './modules/VariationSelector.js';
import EuroplastMenu from './modules/EuroplastMenu.js';

Config();
Breakpoint();

const scroller = Scroller();
scroller.init();

const modules = {
  click: Click(),
  scrollTo: ScrollTo(),
  sectionHeader: SectionHeader(),
  stepScroller: StepScroller(),
  comparison: Comparison(),
  rive: Rive(),
  fixedHeader: FixedHeader(),
  obf: Obf(),
  navigation: Navigation(),
  slider: Slider(),
  variationSelector: VariationSelector(),
  europlastMenu: EuroplastMenu(),
};

Object.values(modules).forEach((module) => {
  module.init();
});
